module.exports = __webpack_public_path__ + "static/media/carICon.50770e86.svg";